import { call, put, takeEvery, takeLeading } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';

import { personalGreeting } from '../../../api';
import { resourceReducer } from '../../utils/resourceReducer';

// Create actions and a reducer for the personal-messages resource
export const [actions, reducer, resourceSagas] = resourceReducer('personal-greetings');

function* readPersonalGreeting() {
  yield takeEvery(actions.indexRequestBegin, function*() {
    try {
      const result = yield call(personalGreeting.get);
      const normalized = normalize(result);
      yield put(actions.indexRequestSuccess(normalized));
    } catch (error) {
      yield put(actions.indexRequestFailure({ error }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error });
    }
  });
}

function* updatePersonalGreeting() {
  yield takeLeading(actions.updateRequestBegin, function*({ payload }) {
    const { args, data } = payload;
    try {
      const { body } = yield call(personalGreeting.update, args, data);
      const normalized = normalize(body);
      yield put(actions.updateRequestSuccess({ ...normalized, args }));
    } catch (error) {
      yield put(actions.updateRequestFailure({ error, args }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error });
    }
  });
}

export const sagas = [readPersonalGreeting, updatePersonalGreeting, ...resourceSagas];
